<template>
  <div v-if="comList && comList.length > 0">
    <div class="m-clear m-comwid m-cominfo">
      <h3>
        <span style="left: 98px"
          >用户评价<i>({{ totalNum }}条)</i></span
        >
      </h3>
      <div class="m-comment" style="padding-bottom: 20px">
        <template v-for="(item, index) in comList">
          <div class="m-clear m-coment" :key="item.id">
            <div class="m-comleft">
              <p>
                <img
                  v-if="item.userHeadImage"
                  :src="item.userHeadImage | imgcrop(80, 80)"
                />
                <img :src="IMAGE_URL + '/header_432.png'" v-else />
              </p>
              <p class="m-com-name">{{ item.userName }}</p>
            </div>
            <div class="m-comright">
              <div class="m-com-rate">
                <scoreCom :newscore="item.star"></scoreCom>
              </div>
              <div class="m-com-date">
                <template v-if="item.weddingDate">
                  {{ formateData(item.weddingDate, "YYYY-MM-DD") }}
                </template>
                {{ item.serviceName
                }}<a class="m-operchakan" style="display: none">查看案例</a>
              </div>
              <p class="m-usercom" v-html="formatText(item.content)"></p>
              <p class="m-piclist" v-if="item.images && item.images.length > 0">
                <template>
                  <span
                    v-for="(img, j) in item.images"
                    :key="item.id"
                    class="imag"
                    :id="'i' + index + 'mag' + j"
                    ><img
                      @click="openImg(item.images, j, 'i' + index + 'mag')"
                      :src="img | imgcrop(72, 72)"
                  /></span>
                </template>
              </p>
              <p class="m-ctime">
                {{ formateData(item.ctime, "YYYY-MM-DD HH:mm") }}
              </p>
            </div>
            <!--<template v-if="item.replyList" v-for="(reply,ind) in item.replyList">
              <div class="r-comment">
                <i></i>
                <p class="r-content"><a>{{vocationname}}-{{workname}}</a>回复说：{{reply.content}}</p>
                <p class="time">{{formateData(reply.ctime,'YYYY-MM-DD HH:mm')}}</p>
              </div>
            </template>-->
          </div>
        </template>
        <div class="m-clear" v-if="pageNum > 1">
          <Pag
            :page="pageNum"
            :total="totalNum"
            :curr="curNum"
            :rowsNum="rows"
            methName="updateComPage"
          ></Pag>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pag from "../common/Page.vue";
import scoreCom from "../common/score.vue";
import api from "../../config/api.js";
import dayjs from "dayjs";
import { imgcrop } from "../../plugin/imgcrop";
export default {
  name: "comment",
  props: ["workerId", "vocation", "usrname"],
  data: function () {
    return {
      totalNum: 1,
      curNum: 1,
      pageNum: 1,
      start: 0,
      rows: 10,
      wid: this.workerId,
      comList: [],
      IMAGE_URL: api.IMAGE_URL,
      NEWIMAGE: api.host,
      workname: this.usrname,
      vocationname: this.vocation,
    };
  },
  components: {
    Pag,
    scoreCom,
  },
  created: function () {
    let vm = this;
    vm.getComment();
    vm.bus.$on("updateComPage", function (obj) {
      vm.start = obj.start;
      vm.curNum = obj.current;
      vm.getComment();
    });
  },
  methods: {
    openImg: function (allImg, index, idname) {
      let imgHref = "";
      let img = "";
      let m = "";
      let m2 = "";
      $.each(allImg, function (index, content) {
        m = imgcrop(content, "1920", "auto", 1);
        m2 = imgcrop(content, "80", "80", 1);
        imgHref +=
          "{src:" + "'" + m + "',thumb:" + "'" + m2 + "',downloadUrl:false},";
      });
      let newImg = imgHref.substring(0, imgHref.length - 1);
      img = eval("[" + newImg + "]");
      lightbox(index, img, idname + index);
    },
    formatText: function (text) {
      return text ? text.replaceAll("\\n", "<br/>").replace(/<br>$/, "") : text;
      //return text;
    },
    formateData: function (ctime, type) {
      return ctime ? dayjs(new Date(ctime)).format(type) : ctime;
    },
    getComment: function () {
      let vm = this;
      let url = api.API_URL + "worker/v1/query/comment/page";
      vm.getNewAjax(
        url,
        { workerId: vm.wid, start: vm.start, rows: vm.rows },
        function (result) {
          //得到所有数据
          vm.comList = result.records;
          vm.totalNum = result.totalRecord;
          vm.pageNum = Math.ceil(result.totalRecord / vm.rows);
        },
        function (result) {},
        function () {}
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// _worker_comment.vue?069c0343